<template>
  <div
    class="menu-animation-right"
    :class="{ show : showRight }"
  >
    <div
      class="menu-overlay"
      @click="event"
    />
    <el-menu
      class="el-menu-vertical-demo"
      :menu-width="getWindowWidth"
      :class="{'has-mobile-footer': hasMobileFooter }"
    >
      <div
        class="mobile-filters"
        :class="showRight"
      >
        <div class="box-header">
          <span
            class="close"
            @click="event"
          ><i class="icon-arrow-b" /></span>
          <span class="header-title">{{ title }}</span>
        </div>
        <menu-filters v-if="page === 'filters'" />
      </div>
    </el-menu>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import mutations from '../../store/temp/temp.mutationlist';
  import MenuFilters from './MenuFilters';

  export default {
    components: { MenuFilters },
    // eslint-disable-next-line vue/require-prop-types
    props: [ 'showRight', 'title', 'page' ],
    data() {
      return {
        animation: 'right',
        maximX: 300,
        minimY: 20,
        maximY: 30,
      };
    },
    computed: {
      ...mapState({
        url: state => state.config ? state.config.apiUrl.replace('/api', '') : '',
      }),
      getWindowWidth() {
        return window.innerWidth;
      },
      hasMobileFooter() {
        return this.$route.name !== 'FeatureAd';
      },
    },
    created() {
      this.$store.watch(
        state => state.temp.event.swipeRight, (value) => {
          if (value.type === 'swipe' && Math.abs(value.srcEventX - value.deltaX) >= this.maximX && Math.abs(value.deltaY) <= this.maximY) {
            this.$store.commit(mutations.TOGGLE_RIGHT_MENU, { show: true });
          }
        },
      );
    },
    methods: {
      event() {
        this.$store.commit(mutations.TOGGLE_RIGHT_MENU, { show: !this.showRight, page: null });
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MenuRight.vue